export const GET_TYPE_ASN_SOURCE = 'GET_TYPE_ASN_SOURCE'
export const GET_TYPE_ASN_SOURCE_EXITO = 'GET_TYPE_ASN_SOURCE_EXITO'
export const GET_TYPE_ASN_SOURCE_ERROR = 'GET_TYPE_ASN_SOURCE_ERROR'
